import { FwDataSourceSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useAvailabilities } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/Availabilities'
import { useExtraData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/ExtraData'
import { usePermissionsData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/PermissionsProvider'

export interface Data {
  expensesCategories: {
    id: number
    label: string
  }[]
  payrollCategory: {
    id: number
    label: string
  }
  agreementDataSubItems: {
    id: string
    label: string
  }[]
}

interface ReturnedData {
  loading: boolean
  data: Data
}

export const useData = (): ReturnedData => {
  const { permissions } = usePermissionsData()
  const { availabilities } = useAvailabilities()
  const { data, loading } = useQuery(FwDataSourceSelectorDocument, {
    skip: !permissions.canSeeExpenses,
  })
  const {
    extraData: {
      payrollConcepts: { currentAssignedLaborCost },
    },
  } = useExtraData()

  const agreementDataSubItems = [
    {
      id: 'salary',
      label: i18n.t(
        'finance.financial_workspace.employee_costs.selector.groups.agreement_cost.subitems.gross_salary'
      ),
    },
  ]

  if (availabilities.features.dev_fw_additional_compensations) {
    agreementDataSubItems.push({
      id: 'compensations',
      label: i18n.t(
        'finance.financial_workspace.employee_costs.selector.groups.agreement_cost.subitems.additional_compensations'
      ),
    })
  }

  return {
    loading,
    data: {
      agreementDataSubItems: agreementDataSubItems,
      expensesCategories: data?.finance.customCategoriesConnection.nodes ?? [],
      payrollCategory: {
        label: currentAssignedLaborCost?.translatedName ?? '',
        id: currentAssignedLaborCost?.id ?? 0,
      },
    },
  }
}
